// extracted by mini-css-extract-plugin
export default {"wrapper":"EditEventLogoItem_wrapper__cEoeI","wrapperActive":"EditEventLogoItem_wrapperActive__AHeFo","text":"EditEventLogoItem_text__pA4j+"};